import React from 'react';

const ErrorPage: React.FC = () => {
  throw new Error('Test error');
};

export default ErrorPage;
